import React from 'react'
//import firebase from '../FirebaseConfig'
import analyticsHelper from '../AnalyticsHelper.js'

import HTHeader from './HTHeader.js'
import HTFooter  from './HTFooter.js'
import HTSearchBar from './HTSearchBar'
import HTContentListRow from './HTContentListRow.js'
import HTFAQListRow from './HTFAQListRow.js'

import lessonsArray from '../content/lessons.js'
import faqsArray from '../content/faqs.js'

const contentArray = lessonsArray.concat(faqsArray)

class HTSearchPage extends React.Component {

  constructor (props) {
    super(props)
    this.onSearch = this.onSearch.bind(this)
    this.buildList = this.buildList.bind(this)
    this.state = {
      includeLessons: this.props.includeLessons != null ? this.props.includeLessons : true,
      includeFAQs: this.props.includeFAQs != null ? this.props.includeFAQs : true,
      initKey: this.parseSearchKey(this.props.location.search),
      filteredLessons:lessonsArray,
      filteredFAQs:faqsArray,
    }
  }

  componentDidMount () {
    this.onSearch(this.state.initKey)
  }

  // if the router is directing to the same component it wont rerender it, so constructor is not called again
  componentWillReceiveProps(nextProps) {
    if (nextProps == this.props) {
      return
    }
    this.setState({
      includeLessons: nextProps.includeLessons != null ? nextProps.includeLessons : true,
      includeFAQs: nextProps.includeFAQs != null ? nextProps.includeFAQs : true,
      initKey: this.parseSearchKey(nextProps.location.search),
      filteredLessons:lessonsArray,
      filteredFAQs:faqsArray,
    })
  }

  // string
  parseSearchKey (queryParams) {
    let index = queryParams.indexOf("key") + 4
    let key = queryParams.substring(index)
    key = key.replace("%20", " ")
    return key
  }

  onSearch (searchText) {
    if (searchText === "") {
      this.setState({filteredLessons:lessonsArray})
      this.setState({filteredFAQs:faqsArray})
    } else {
      let filteredLessons = this.filterLessons(lessonsArray,searchText)
      this.setState({filteredLessons:filteredLessons})
      let filteredFAQs = this.filterFAQs(faqsArray,searchText)
      this.setState({filteredFAQs:filteredFAQs})
    }
    analyticsHelper.genEvent(analyticsHelper.EVENT_SEARCH, analyticsHelper.SEARCH_SEARCH_PAGE, searchText)
    //firebase.analytics().logEvent('search_from_SearchPage with: '+searchText);
  }

  // array of objects, string
  filterLessons (source,key) {
    var filteredList = []
    source.forEach((item, i) => {
      if (item.title.toLowerCase().includes(key.toLowerCase())) {
        filteredList.push(item)
        return
      }

      let added = false // to avoid duplicates
      item.tags.forEach((oneTag, i) => {
        if (added) {return}
        if (oneTag.toLowerCase().includes(key.toLowerCase())) {
          filteredList.push(item)
          added = true
          return
        }
      });
    });
    return filteredList
  }

  // array of objects, string
  filterFAQs (source,key) {
    var filteredList = []
    source.forEach((item, i) => {

      if (item.question.toLowerCase().includes(key.toLowerCase())) {
        filteredList.push(item)
        return
      }

      let added = false // to avoid duplicates
      item.tags.forEach((oneTag, i) => {
        if (added) {return}
        if (oneTag.toLowerCase().includes(key.toLowerCase())) {
          filteredList.push(item)
          added = true
          return
        }
      });

      if (added) {
        return
      }

      /*if (item.answer.toLowerCase().includes(key.toLowerCase())) {
        filteredList.push(item)
        return
      }*/

    });
    //console.log("list "+JSON.stringify(filteredList))
    return filteredList
  }

  buildList () {

    if (this.state.filteredLessons.length == 0 && this.state.filteredFAQs.length == 0) {
      return (<div id="no_results">* No Results *</div>)
    }

    let list = []
    //console.log(this.state.filtered)
    if (this.state.includeFAQs) {
      this.state.filteredFAQs.forEach(function (oneFAQ,index) {
        list.push(<HTFAQListRow content={oneFAQ} key={"faq_"+oneFAQ.uid} />)
      })
    }
    if (this.state.includeLessons) {
      this.state.filteredLessons.forEach(function (oneContent,index) {
        list.push(<HTContentListRow content={oneContent} key={"lesson_"+oneContent.path} />)
      })
    }
    return (
      <div id="row-container">
        {list}
      </div>
    )
  }

  render () {
    return (
      <main>
        <HTHeader HTTitle="Home Theory" onPath="/search"/>
        <HTSearchBar onSearch={this.onSearch} initKey={this.state.initKey} />
        {this.buildList()}
        <HTFooter />
      </main>
    )
  }
}

export default HTSearchPage



// WEBPACK FOOTER //
// src/components/HTSearchPage.js